import {
  UserModuleModel,
  UserModulesExists,
} from "../../shared/models/general-model";
import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { Modules } from "../../shared/models/general-model";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-outlet-onboarding",
  templateUrl: "./outlet-onboarding.component.html",
  styleUrls: ["./outlet-onboarding.component.scss"],
})
export class OutletOnboardingComponent implements OnInit {
  min: number;
  max: number;
  searchPage = 1;
  search: any = "";
  options: Array<any> = [];
  errorMsg = "";
  modalRef: BsModalRef;
  message: string;
  show: boolean;
  importFile: boolean = false;
  editFile: boolean = false;
  excel_data: boolean = true;
  csmFile: any;
  detailedOutlet: any = {};

  rejectedExcelData: any = [];
  approvedExcelData: any = [];
  rejectedExcel: any = "";
  approvedExcel: any = "";
  file: any;

  public headers;
  public columns;
  public save = true;
  public notice = true;
  public month;
  public year;
  public ro_name = [];
  public moduleId;
  public modules: Modules[];
  public userList: any[];
  public excel = [
    {
      outlet_code: "",
    },
  ];
  fileName: string = "";
  excelData: any[];
  outletListData: any = [];
  page = 1;
  getPaginationCount: any = "";
  totalPages: any = "";
  outletForm!: FormGroup;
  selectedOutletId!: any;

  // testExcelData : any = [];

  constructor(
    private exportExcelService: ExportExcelService,
    private xls: XlsxService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private uploadFile: UploadZipService,
    // private modalService: BsModalService,
    public alertService: AlertService,
    public ngxService: NgxUiLoaderService,
    public http: HttpClient,
    private fb: FormBuilder
  ) {
    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        console.log(message);
        //this.getList();
        // this.getUserExportList();
      }
    });
  }

  ngOnInit() {
    this.getOutletList();
  }
  getOutletList() {
    this.apiService
      .getHeaders(
        this.apiConfig.getListOutlet +
          `?program_id=1&page=${this.page}&search=${this.search}`
      )
      .subscribe(
        (res: any) => {
          console.log(res);
          this.outletListData = res.body.data.outlets;
          this.getPaginationCount = res.headers.get("x-pagination-total-count");
          this.totalPages = res.headers.get("x-pagination-per-page");

          console.log(this.getPaginationCount, this.totalPages);
        },
        (err: any) => {
          console.log(err);
        }
      );
  }
  filter() {
    this.getOutletList();
  }
  paginationClick(page: number) {
    this.page = page;
    this.getOutletList();
  }
  selectedStateCode: any;
  openEditModal(modalRef: any, outlet: any) {
    this.selectedOutletId = outlet.id;
    this.selectedStateCode = outlet.state_code;
    this.outletForm = this.fb.group({
      outlet_code: [{ value: outlet.outlet_code, disabled: true }],
      channel_desc: [{ value: outlet.channel_desc, disabled: true }],
      state_name: [{ value: outlet.state_name, disabled: true }],
      region_name: [{ value: outlet.region_name, disabled: true }],
      outlet_name: [
        outlet.outlet_name,
        [Validators.required, Validators.maxLength(100)],
      ],
    });

    this.modalService.open(modalRef, { centered: true });
  }

  saveOutletChanges(modalRef: any) {
    if (this.outletForm.invalid) return;
    let payload = {
      id: this.selectedOutletId,
      state_code: this.selectedStateCode,
      outlet_name: this.outletForm.value.outlet_name,
    };
    this.apiService.post(this.apiConfig.editOutlet, payload).subscribe(
      (res: any) => {
        this.toast.Success(res.body.data.message);
        this.selectedOutletId = "";
        this.selectedStateCode = "";
        this.outletForm.reset();
        this.getOutletList();
        this.modalService.dismissAll();
        console.log(res);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  toggleStatus(item) {
    let payload = {
      outlet_id: item.id,
      flag: item.status == 1 ? 0 : 1,
    };
    this.apiService.post(this.apiConfig.disableOutlet, payload).subscribe(
      (res: any) => {
        console.log(res);
        this.toast.Success(res.body.data.message);
        this.getOutletList();
      },
      (err: any) => {
        this.getOutletList();
      }
    );
  }

  downloadExcel() {
    let header = [
      "Outlet_Code",
      "Outlet_Name",
      "Outlet_Channel",
      "Outlet_State",
    ];
    let filename = "outlet_onbording_";
    this.exportExcelService.commonPrintHeaders(header, filename);
  }

  xlsxView(data) {
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        let data = {
          outlets: [],
        };
        result.forEach((e) => {
          data.outlets.push(e);
        });
        this.apiService
          .post(this.apiConfig.importNewUsers, result)
          .subscribe((res: any) => {
            console.log(res);
          });
      },
      (reason) => {}
    );
  }

  importExcel(event) {
    // debugger
    this.editFile = true;
    this.importFile = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.file = event.target.files[0];
    }
    this.xls.uploadXlsx(event).then((res: any) => {
      // this.testExcelData = res.data
      // console.log(this.testExcelData)

      // setTimeout(()=>{
      //   this.checkExcelData()
      // },3000)
      this.headers = res.headers;
      this.columns = res.data;
      console.log(this.headers, this.columns);
      this.save = false;
      this.notice = false;
      this.excelData = res;
      this.editFile = false;
      //  debugger
      if (this.columns.length != 0) {
        this.excel_data = false;
      }
    });
  }

  onSave(modal) {
    this.modalService.open(modal, { size: "xl" });
  }

  openExcelDeatail(excelmodel, data) {
    this.modalService.dismissAll();
    let payload = {
      data: data,
    };

    this.apiService
      .post(this.apiConfig.outletOnboarding, payload)
      .subscribe((res: any) => {
        console.log(res.body.data.rejected);
        this.toast.Success("Excel Upload Sucessfully");
        this.rejectedExcelData = res.body.data.failure_array;
        this.approvedExcelData = res.body.data.inserted;
        this.rejectedExcel = res.body.data.failure_count;
        this.approvedExcel = res.body.data.success_count;
        this.modalService.open(excelmodel);
      });
  }

  ApprovedExacel() {
    console.log("approved : ", this.approvedExcelData);

    let sheetName = "sheet1";
    let filename = "outlet_onbording_approved";
    let excelData = this.approvedExcelData;
    let excelArray = [
      { header: "Outlet_Code", key: "Outlet Code" },
      { header: "reason", key: "Error" },
    ];
    this.exportExcelService.DownloadstaticReportExcel(
      filename,
      sheetName,
      excelData,
      excelArray
    );
  }
  rejectedExacel() {
    let sheetName = "sheet1";
    let filename = "outlet_onbording_rejected";
    let excelData = this.rejectedExcelData;
    let excelArray = [
      { header: "Outlet_Code", key: "Outlet Code" },
      { header: "reason", key: "Error" },
    ];
    this.exportExcelService.DownloadstaticReportExcel(
      filename,
      sheetName,
      excelData,
      excelArray
    );
  }

  dismissModal() {
    this.file = "";
    this.fileName = "";
    this.csmFile = null;
    this.excel_data = true;
    this.modalService.dismissAll();
  }

  // checkExcelData(){
  //     this.http.get("https://mysqlapi.cokeandmeals.bigcityvoucher.co.in/v1/resturants/nearbyrestaurants?latitude=12.9761095&longitude=77.5990435").subscribe((res : any)=>{
  //       console.log(res)
  //       res.data.forEach((e : any)=>{
  //         this.testExcelData.forEach((test : any)=>{
  //           if(e.restaurant_name == test.Restaurant_name_as_per_the_Façade && e.address == test.address){
  //             console.log("test : pass")
  //           }
  //         })
  //       })
  //     })
  // }
}
